export const menuItems = [
    {
        id: 100,
        label: "menuitems.menu.text",
        isTitle: true,
        subItems: [ {
            id: 110, 
            link: "/",
            role:["SuperAdmin","SatTalep","SatAdmin","SatKullanici"],
            parentId: 100
        }, {
            id: 110, 
            link: "/userroles",
            hide: true,
            role:["SuperAdmin","SatAdmin"],
            parentId: 100
        }, {
            id: 110, 
            link: "/logout",
            hide: true,
            role:["*"],
            parentId: 100
        },
        {
            id: 100, 
            isTitle: true,
            link: "/ouserbirimyetki",
            hide: true,
            role: ["SuperAdmin","SatAdmin"],
            subItems: [],
        },
        {
            id: 110, 
            link: "/yaklasikmaliyetgiris",
            hide: true,
            role:["*"],
            parentId: 100
        },
        {
            id: 110, 
            link: "/yayinlananihaleler",
            hide: true,
            role:["*"],
            parentId: 100
        }, 
    ]
    }, 
 
 
    { 
        id: 200,
        label: "menuitems.tanimla.text",
        icon: "bx bx-radar",
        subItems: [
            {
                id: 210,
                label: "menuitems.tanimla.list.satharcamabutce",
                link: "/satharcamabutce",
                role:["SatAdmin"],
                parentId: 200,
            },
            {
                id: 220,
                label: "menuitems.tanimla.list.ofirma",
                link: "/ofirma",
                role:["SuperAdmin","SatAdmin","SatKullanici"],
                parentId: 200
            },
            {
                id: 230,
                label: "menuitems.tanimla.list.omalzemegrup",
                link: "/omalzemegrup",
                role:["SuperAdmin","SatAdmin","SatIhaleHazirlik"],
                parentId: 200
            },
            {
                id: 230,
                label: "menuitems.tanimla.list.omalzeme",
                link: "/omalzeme",
                role:["SuperAdmin","SatAdmin","SatIhaleHazirlik"],
                parentId: 200
            }

        ]
    },
    { 
        id: 300,
        label: "menuitems.talep.text",
        icon: "bx bx-copy-alt",
        subItems: [
            {
                id: 310,
                label: "menuitems.talep.list.toplutalep",
                link: "/toplutalep",
               role:["SuperAdmin","SatAdmin","SatTopluTalep"],
                parentId: 300
            },
            {
                id: 310,
                label: "menuitems.talep.list.sattalep",
                link: "/sattalepler",
                role:["SuperAdmin","SatTalep","SatKullanici","SatAdmin"],
                parentId: 300
            },
            {
                id: 320,
                label: "menuitems.talep.list.sattaleponay",
                link: "/sattaleponay",
               role:["SuperAdmin","SatTalep","SatAdmin"],
                parentId: 300
            }
        ]
    },
    {
        id: 400,
        label: "menuitems.hazirlik.text",
        icon: "bx bx-share-alt",
        subItems: [
            {
                id: 410,
                label: "menuitems.hazirlik.list.dosya",
                link: "/satdosya",
               role:["SuperAdmin","SatAdmin","SatIhaleHazirlik"],
                parentId: 400
            },
            {
                id: 420, 
                link: "/dosyaislemleri",
               role:["SuperAdmin","SatAdmin","SatIhaleHazirlik"],
                hide:true,
                parentId: 400
            },
            {
                id: 430, 
                link: "/BirimButceHarcamalari",
                role:["SuperAdmin","SatAdmin","SatIhaleHazirlik"],
                hide:true,
                parentId: 400
            },
            {
                id: 410,
                label: "menuitems.hazirlik.list.raporsatdosyafatura",
                link: "/raporsatdosyafatura",
               role:["SuperAdmin","SatAdmin","SatIhaleHazirlik"],
                parentId: 400
            },
        ]
    },
 
  
 
];

